__turbopack_context__.v({
  "active": "SearchSort-module-scss-module__EjyTWG__active",
  "search__sort": "SearchSort-module-scss-module__EjyTWG__search__sort",
});
